import { message } from "antd";
import { useState } from "react";
import { api } from "../../../api";
import { Button } from "../../../externalComponents/tailwind/button";

export default function CancelStoppedCampaignDialog({
  isOpen,
  onClose,
  batchToCancel,
  user,
  onSuccess,
}) {
  const [cancelling, setCancelling] = useState(false);

  const handleConfirmCancel = async () => {
    if (!batchToCancel) {
      return;
    }

    setCancelling(true);
    try {
      await api.cancelStoppedCampaign({
        customerId: user.customerId,
        sendingBatchId: batchToCancel.sendingBatchId,
      });

      message.success("Campaign cancelled successfully!");
      onSuccess(batchToCancel.sendingBatchId);
      onClose();
    } catch (error) {
      console.error("Error cancelling campaign:", error);
      message.error("Failed to cancel campaign. Please try again.");
    } finally {
      setCancelling(false);
    }
  };

  if (!isOpen || !batchToCancel) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md mx-4">
        <h3 className="text-lg font-bold mb-4">Cancel Campaign</h3>
        <p className="text-gray-700 mb-6">
          Are you sure you want to cancel this campaign?
          <br />
          This will cancel all <strong>
            {batchToCancel.totalContacts}
          </strong>{" "}
          remaining message(s).
        </p>
        <div className="flex justify-end gap-3">
          <Button
            color="secondaryButton"
            onClick={onClose}
            disabled={cancelling}
          >
            No
          </Button>
          <Button
            color="primaryButton"
            onClick={handleConfirmCancel}
            disabled={cancelling}
          >
            {cancelling ? "Cancelling..." : "Cancel"}
          </Button>
        </div>
      </div>
    </div>
  );
}
